import { createIcon } from '@chakra-ui/react'

export const TwitterIcon = createIcon({
  displayName: 'TwitterIcon',
  viewBox: '0 0 22 18',
  d: 'M19.69 4.526c.013.191.013.383.013.576 0 5.888-4.507 12.678-12.747 12.678v-.003a12.732 12.732 0 0 1-6.867-1.998 9.027 9.027 0 0 0 6.63-1.847 4.483 4.483 0 0 1-4.185-3.094 4.49 4.49 0 0 0 2.022-.077A4.462 4.462 0 0 1 .963 6.394v-.057a4.47 4.47 0 0 0 2.033.558A4.447 4.447 0 0 1 1.609.945 12.738 12.738 0 0 0 10.842 5.6a4.443 4.443 0 0 1 1.296-4.257 4.502 4.502 0 0 1 6.339.193A9.019 9.019 0 0 0 21.322.454a4.477 4.477 0 0 1-1.97 2.465 8.947 8.947 0 0 0 2.573-.702 9.076 9.076 0 0 1-2.236 2.309Z',
})
